import React, { useState } from 'react';
//import axios from 'axios';
import { withTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

//import Conf from 'utils/Conf';



const PaiementCinecheque = ({
  onClose,
  go,
  email,
  conf,
  seance,
  t,
}) => {
  const [barCode, setBarCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setBarCode(e.target.value);
    setError('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // call api with barCode
    setLoading(true);
    //const seanceId = seance.seance_id;

    if (!barCode) return;

    setTimeout(() => {
      setError('cinéchèque non valide');
      setLoading(false);
    }, 1000);
    return;
    // axios.post(`${Conf.apiUrl2}/cinecheque_payment/${seanceId}`, {
    //   barCode,
    // }, { withCredentials: true }).then((res) => {
    //   setLoading(false);
    //   if (res.data.status === 'error') {
    //     // TODO: gérer l'erreur
    //     setError('erreur');
    //     //this.props.go(5);
    //     return;
    //   }
    //
    //   if (res.data.authorized === true) {
    //     this.go(2);
    //   } else {
    //     setError('paiement refusé');
    //   }
    //   return;
    // }).catch((error) => {
    //   setLoading(false);
    //   return;
    // });
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <TextField
          type="text"
          autoFocus
          name="barCode"
          className="text-input"
          variant="filled"
          label="Code Cinéchèque" /* TODO: translate */
          value={barCode}
          onChange={handleChange}
          fullWidth
          error={!!error}
          helperText={error}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={!barCode}
        >
          {t('valider')}
        </Button>
      </form>
      {loading && <CircularProgress />}
    </div>
  );
};

export default withTranslation()(PaiementCinecheque);
